import React from "react";
import { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './styles/style.css';

//Routes
import HomePage from 'pages/homepage/homePage';
import Emptypage from 'pages/404page/404.js';
import GoldPage from "pages/goldpage/gold";

const AboutPage = React.lazy(() => import("pages/aboutpage/about"));
const LoanPage = React.lazy(() => import("pages/loanpage/loans"));
const HubPage = React.lazy(() => import("pages/hubpage/hub"));
const SupportPage = React.lazy(() => import("pages/bussupportpage/support"));
const ContactPage = React.lazy(() => import("pages/contactpage/contact"));
const CareersPage = React.lazy(() => import("pages/careerspage/career"));
const CommunityPage = React.lazy(() => import("pages/community/community"));
const PressPage = React.lazy(() => import("pages/presspage/press"));
const StoriesPage = React.lazy(() => import("pages/impactstories/stories"));
const MentorsPage = React.lazy(() => import("pages/mentorspage/mentor"));
const TermsPage = React.lazy(() => import("pages/termspage/terms"));
const LearnPage = React.lazy(() => import("pages/learnpage/learn"));
const GoldRegisterPage = React.lazy(() => import("pages/goldpage/register/register"));
const GoldRegisterSucessPage = React.lazy(() => import("pages/goldpage/register/register_success"));
const GoldFaqPage = React.lazy(() => import("pages/goldpage/faqs/faq_main"));
const GoldIwdPage = React.lazy(() => import("pages/goldpage/promotion/iwdpage/iwd"));
const GoldPricingPage = React.lazy(() => import("pages/goldpage/register/pricing"));

const BestiePage = React.lazy(() => import("pages/businessbestiepage/bestie"));
const BestieFormStepOnePage = React.lazy(() => import("pages/businessbestiepage/form_step_1"));
const BestieFormStepTwoPage = React.lazy(() => import("pages/businessbestiepage/form_step_2"));
const BestieFormStepThreePage = React.lazy(() => import("pages/businessbestiepage/form_step_3"));

// const BestieRatingFormStepOnePage = React.lazy(() => import("pages/businessbestiepage/rating/bestie_rating_one"));
const BestieRatingFormStepTwoPage = React.lazy(() => import("pages/businessbestiepage/rating/bestie_rating_two"));


const Calculators = React.lazy(() => import("pages/resources/calculatorpage/calculator"));
const ProfitMarginCalculator = React.lazy(() => import("pages/resources/calculatorpage/category/profit_margin"));
const CashRunwayCalculator = React.lazy(() => import("pages/resources/calculatorpage/category/cash_runway"));
const DebtIncomeCalculator = React.lazy(() => import("pages/resources/calculatorpage/category/debt_to_income"));
const EmployeeCostCalculator = React.lazy(() => import("pages/resources/calculatorpage/category/employee_cost"));
const SellingPriceCalculator = React.lazy(() => import("pages/resources/calculatorpage/category/selling_price"));
const CustomerLifetimeValueCalculator = React.lazy(() => import("pages/resources/calculatorpage/category/customer_lifetime"));
const BreakEvenCalculator = React.lazy(() => import("pages/resources/calculatorpage/category/break_even"));
const ChurnRateCalculator = React.lazy(() => import("pages/resources/calculatorpage/category/churn_rate"));
const ReturnOnInvestmentCalculator = React.lazy(() => import("pages/resources/calculatorpage/category/return_investment"));


const NewsletterPage = React.lazy(() => import("pages/newsletter/newsletter"));


//Quiz
const BusinessSurvivalQuizIntro = React.lazy(() => import("pages/resources/quiz/business_survival/intro"));
const BusinessSurvivalQuiz = React.lazy(() => import("pages/resources/quiz/business_survival/quiz"));
const BusinessSurvivalQuizResult = React.lazy(() => import("pages/resources/quiz/business_survival/result"));




function App() {
  return (
    <Router>
      <Suspense fallback={<div>Impacting women financially....</div>} >
        <Routes>
          <Route
            path="/about"
            element={
              <Suspense >
                <AboutPage />
              </Suspense>
            }
          />

          <Route
            path="/loan"
            element={
              <Suspense >
                <LoanPage />
              </Suspense>
            }
          />
          
          <Route
            path="/hub"
            element={
              <Suspense >
                <HubPage />
              </Suspense>
            }
          />
          <Route
            path="/business-support"
            element={
              <Suspense >
                <SupportPage />
              </Suspense>
            }
          />
          <Route
            path="/contact-us"
            element={
              <Suspense >
                <ContactPage />
              </Suspense>
            }
          />
          <Route
            path="/careers"
            element={
              <Suspense>
                <CareersPage />
              </Suspense>
            }
          />
          <Route
            path="/community"
            element={
              <Suspense>
                <CommunityPage />
              </Suspense>
            }
          />
          <Route
            path="/press"
            element={
              <Suspense >
                <PressPage />
              </Suspense>
            }
          />
          <Route
            path="/stories"
            element={
              <Suspense >
                <StoriesPage />
              </Suspense>
            }
          />
          <Route
            path="/mentors"
            element={
              <Suspense >
                <MentorsPage />
              </Suspense>
            }
          />
          <Route
            path="/terms"
            element={
              <Suspense >
                <TermsPage />
              </Suspense>
            }
          />
          <Route
            path="/learn"
            element={
              <Suspense >
                <LearnPage />
              </Suspense>
            }
          />
          <Route
            path="/loans"
            element={
              <Suspense >
                <LoanPage />
              </Suspense>
            }
          />

          <Route
            path="/gold/register"
            element={
              <Suspense >
                <GoldRegisterPage />
              </Suspense>
            }
          />

          <Route
            path="/gold/pricing"
            element={
              <Suspense >
                <GoldPricingPage />
              </Suspense>
            }
          />

          <Route
            path="/gold/register/success"
            element={
              <Suspense >
                <GoldRegisterSucessPage />
              </Suspense>
            }
          />

          <Route
            path="/gold/faq"
            element={
              <Suspense >
                <GoldFaqPage />
              </Suspense>
            }
          />

          <Route
            path="/gold/promotion/iwd"
            element={
              <Suspense >
                <GoldIwdPage />
              </Suspense>
            }
          />


          <Route
            path="/sync-ai"
            element={
              <Suspense >
                <BestiePage />
              </Suspense>
            }
          />

          <Route
            path="/sync-ai/form/step-1"
            element={
              <Suspense >
                <BestieFormStepOnePage />
              </Suspense>
            }
          />

          <Route
            path="/sync-ai/form/step-2"
            element={
              <Suspense >
                <BestieFormStepTwoPage />
              </Suspense>
            }
          />

          <Route
            path="/sync-ai/form/step-3"
            element={
              <Suspense >
                <BestieFormStepThreePage />
              </Suspense>
            }
          />

          <Route
            path="/sync-ai/feedback"
            element={
              <Suspense >
                <BestieRatingFormStepTwoPage />
              </Suspense>
            }
          />

          <Route
            path="/calculators"
            element={
              <Suspense >
                <Calculators />
              </Suspense>
            }
          />

          <Route
            path="/calculators/profit-margin"
            element={
              <Suspense>
                <ProfitMarginCalculator />
              </Suspense>
            }
          />
          <Route
            path="/calculators/cash-runway"
            element={
              <Suspense>
                <CashRunwayCalculator />
              </Suspense>
            }
          />

          <Route
            path="/calculators/debt-to-income"
            element={
              <Suspense>
                <DebtIncomeCalculator />
              </Suspense>
            }
          />


          <Route
            path="/calculators/employee-cost"
            element={
              <Suspense>
                <EmployeeCostCalculator />
              </Suspense>
            }
          />

          <Route
            path="/calculators/selling-price"
            element={
              <Suspense>
                <SellingPriceCalculator />
              </Suspense>
            }
          />

          <Route
            path="/calculators/customer-lifetime"
            element={
              <Suspense>
                <CustomerLifetimeValueCalculator />
              </Suspense>
            }
          />

          <Route
            path="/calculators/break-even"
            element={
              <Suspense>
                <BreakEvenCalculator />
              </Suspense>
            }
          />

          <Route
            path="/calculators/churn-rate"
            element={
              <Suspense>
                <ChurnRateCalculator />
              </Suspense>
            }
          />

          <Route
            path="/calculators/return-on-investment"
            element={
              <Suspense>
                <ReturnOnInvestmentCalculator />
              </Suspense>
            }
          />

          <Route
            path="/quiz/business-survival/intro"
            element={
              <Suspense>
                <BusinessSurvivalQuizIntro />
              </Suspense>
            }
          />

          <Route
            path="/quiz/business-survival"
            element={
              <Suspense>
                <BusinessSurvivalQuiz />
              </Suspense>
            }
          />

          <Route
            path="/quiz/business-survival/result"
            element={
              <Suspense>
                <BusinessSurvivalQuizResult />
              </Suspense>
            }
          />

          <Route path="/" element={<HomePage />} />
          <Route path="*" element={<Emptypage />} />
          <Route path="/gold" element={<GoldPage />} />
          <Route path="/newsletter" element={<NewsletterPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
